
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import Orientation from '@/utils/directives/DeviceOrientation'
import { isMobileDevice } from '~/utils/extension'
import { usePreferencesStore } from '@/stores/preferences'
import { NeoIcon } from '@kodadot1/brick'

const components = {
  BasicImage: () => import('@/components/shared/view/BasicImage.vue'),
  NeoIcon,
}

const directives = {
  orientation: Orientation,
}

@Component({ components, directives })
export default class BaseGalleryItem extends Vue {
  @Prop({ type: String, default: '' }) public image!: string
  @Prop(String) public animationUrl!: string
  @Prop({ type: String, default: 'KodaDot NFT minted multimedia' })
  public description!: string
  @Prop(Boolean) public imageVisible!: boolean
  @Prop(Boolean) public isLoading!: boolean
  @Prop(String) public mimeType!: string
  private preferencesStore = usePreferencesStore()

  private isFullScreenView = false
  private isTileView = false
  private viewMode = isMobileDevice
    ? 'theater'
    : this.preferencesStore.getTheatreView

  get isGyroEffectEnabled(): boolean {
    if (isMobileDevice) {
      return true
    }
    return this.preferencesStore.getEnableGyroEffect
  }

  get itemImage(): string {
    return (
      this.image ||
      (this.$colorMode.preference === 'dark'
        ? '/placeholder.webp'
        : '/placeholder-white.webp')
    )
  }

  public toggleView(): void {
    this.viewMode = this.viewMode === 'default' ? 'theatre' : 'default'
  }

  public toggleTileView(): void {
    this.setTileView(!this.isTileView)
  }

  public setTileView(value: boolean) {
    this.isTileView = value
  }

  public setFullScreenView(value: boolean) {
    this.isFullScreenView = value
  }

  public toggleFullScreen(): void {
    this.setFullScreenView(!this.isFullScreenView)
  }

  public minimize(): void {
    this.setFullScreenView(false)
  }
  public exitTileView(): void {
    this.setTileView(false)
  }

  public onImageError(e: any) {
    this.$consola.warn('Image error', e)
  }
}
